import React from "react";

interface HeatmapControlsProps {
  useMaxDensity: boolean;
  onToggleDensity: () => void;
  hasMaxDensityData: boolean;
  isFixedSeating: boolean;
}

export const HeatmapControls: React.FC<HeatmapControlsProps> = ({
  useMaxDensity,
  onToggleDensity,
  hasMaxDensityData,
  isFixedSeating,
}) => {
  if (!hasMaxDensityData || !isFixedSeating) {
    return null;
  }

  return (
    <div className="density-toggle-container">
      <label className="density-toggle-label">
        <span className={useMaxDensity ? "active" : ""}>
          Максимальна щільність
        </span>
        <button
          className={`density-toggle ${
            useMaxDensity ? "max-density" : "regular"
          }`}
          onClick={onToggleDensity}
          aria-label="Переключити режим відображення"
        >
          <span className="toggle-slider"></span>
        </button>
        <span className={!useMaxDensity ? "active" : ""}>Реальна розсадка</span>
      </label>
    </div>
  );
};
